import { Button, LoadingAnimation, Text } from '@/components'
import { AlertMessage, Link } from 'app-components'
import { UtilityAccountDetails } from '@/app/features/utility-account-fields'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import useExternalNavigation from '@/app/hooks/useExternalNavigation'
import useViewModel, {
  AccountNumberEntryProps,
} from 'features/connect-utility/AccountNumberEntry/useViewModel'

function AccountDetailsSubtitle({ website }: { website: string | null }) {
  const { externallyNavigate } = useExternalNavigation()

  return (
    <Text variant="body2">
      Upload a utility bill and we'll find your account details automatically or
      enter them manually. You can find them on your most recent utility bill or
      by logging into your{' '}
      {website ? (
        <Link onClick={() => externallyNavigate(website)}>
          utility's website
        </Link>
      ) : (
        "utility's website"
      )}
      .
    </Text>
  )
}

export default function AccountNumberEntry(props: AccountNumberEntryProps) {
  const {
    isLoading,
    config,
    upload,
    extractedValues,
    formik,
    register,
    utilityWebsite,
    submit,
    skip,
    canProceed,
    submissionErrors,
  } = useViewModel(props)

  if (isLoading) {
    return <LoadingAnimation type="falling" centered />
  }

  return (
    <UtilityAccountDetails
      title="Enter account details"
      subtitle={<AccountDetailsSubtitle website={utilityWebsite} />}
      upload={{
        fileInputRef: upload.fileInputRef,
        handleFilesUploaded: upload.handleFilesUploaded,
        handleUploadClick: upload.handleUploadClick,
        fileUploadStatus: upload.fileUploadStatus,
        fileUploadName: upload.fileUploadName,
        uploadErrorMessage: upload.uploadErrorMessage,
        uploadSuccessMessage: upload.uploadSuccessMessage,
        billUrl: upload.billUrl,
      }}
      fields={{
        config,
        register,
        values: formik.values,
        errors: formik.errors,
        touched: formik.touched,
        extractedValues,
      }}
      footer={
        <div className="flex flex-col gap-4">
          {submissionErrors && (
            <AlertMessage variant="error">{submissionErrors}</AlertMessage>
          )}
          <ButtonContainer>
            <Button id="skip-btn" onClick={skip} variant="secondary">
              Skip
            </Button>
            <Button id="submit-btn" disabled={!canProceed} onClick={submit}>
              Next
            </Button>
          </ButtonContainer>
        </div>
      }
    />
  )
}
